import styled from 'styled-components';
import { getSpacing } from 'stylesheetB2b';

export const BoxEffectContainer = styled.div<{
  color: string;
  isSelected: boolean;
}>`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: ${getSpacing(4)};
    background-color: ${({ color }) => color};
    border-radius: ${getSpacing(2)};
    aspect-ratio: 1;
    width: 100%;
    cursor: pointer;
    border: ${({ isSelected }) => (isSelected ? '2px solid white' : 'none')};
    box-shadow: ${({ isSelected }) =>
      isSelected ? '0px 0px 20px 0px rgba(255, 255, 255, 0.75)' : 'none'};
`;

export const Title = styled.h3`
    font-size: ${getSpacing(3)};
    font-weight: bold;
    color: black;
`;
